import * as globals from '@wandb/weave/common/css/globals.styles';
import {TargetBlank} from '@wandb/weave/common/util/links';
// eslint-disable-next-line wandb/no-deprecated-imports
import {
  Button as SemanticButton,
  Message,
  Modal as SemanticModal,
} from 'semantic-ui-react';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const Modal = styled(SemanticModal)`
  max-width: 400px;
  padding: 30px;
  border-radius: 8px;
`;

export const Header = styled.div`
  font-family: ${globals.fontName};
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 25px;
  letter-spacing: 0em;
  padding-top: 8px;
  padding-bottom: 24px;
  text-align: left;
`;

export const Content = styled.div`
  font-family: ${globals.fontName};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;

export const PendingMessage = styled(Message)`
  && {
    margin: 0 24px 24px 24px;
    padding: 18px 24px;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  padding: 0px;
`;

export const CancelButton = styled(SemanticButton)`
  &&&& {
    border: none;
    cursor: pointer;
    color: ${globals.MOON_800};
    font-weight: 600;
    background: none;
`;

export const InviteButton = styled(SemanticButton)`
  &&&& {
    background-color: ${globals.TEAL_500};
    color: ${globals.WHITE};
    font-weight: 600;
    border: none;
    cursor: pointer;
  }
`;

export const DescriptionList = styled.div`
  margin-left: 4px;
  margin-bottom: 16px;
  color: ${globals.MOON_600};
  padding: 0;
  font-size: 16px;
  font-weight: 400;
`;

export const DescriptionListItem = styled.li`
  line-height: 20px;
  &&&& {
    padding: 0;
    align-items: baseline;
  }
`;

export const ViewPricingLink = styled(TargetBlank)`
  color: ${globals.TEAL_600};

  &:hover {
    color: ${globals.TEAL_500};
  }
`;
